const Backbone = require('backbone');
const SlickHelper = require('views/store/common/helpers/slick');
require('slick-carousel');

module.exports = Backbone.View.extend({
	el: '.js-body-container',
	initialize: function() {
		if (!window.BCOM.device.isMobile) {
			this._initFade();
		} else {
			this._initCarousel();
		}
	},
	_initCarousel() {
		this.$slider = this.$el.find('.js-page-content .js-img-swipe');
		this.$slider.on('init', () => {
			// show hidden slides
			$('.slide.dn')
				.removeClass('dn')
				.addClass('db');
		});
		if (this.$slider && this.$slider.length) {
			this.$slider.not('.slick-initialized').slick({
				infinite: false,
				arrows: false,
				dots: true,
				slidesToShow: 1,
				slidesToScroll: 1
			});
			SlickHelper.addClassesToLi(this.$slider);
		}
	},
	_initFade() {
		const $superSplash = this.$el.find('.js-top-splash-content .js-super-splash');
		if ($superSplash.length) {
			$superSplash.slick({
				dots: false,
				infinite: true,
				speed: 800,
				fade: true,
				draggable: false,
				autoplay: true,
				autoplaySpeed: 3000,
				arrows: false,
				cssEase: 'linear'
			});
		}
	}
});
